module.exports = __webpack_public_path__ + "img/edit.e8d05550.svg";